import { CoursePageLayout } from "../courseBlocks";
import { mathMenuData } from "../../../data/SubjectMenu/mathMenuData";
import { mathsImg } from "../../../data/SubjectContent/maths/img";
import { mathsBaseBlocks } from "../../../data/SubjectContent/maths/base";

export function PageMathsBase() {
    return (
        <CoursePageLayout
            title="數學科 | 校本課程特色"
            subtitle="SCHOOL-BASED CURRICULUM"
            menuData={mathMenuData}
            nowIndex={1}
            topImage={{ src: mathsImg.baseTop }}
            blocks={mathsBaseBlocks}
        />
    );
}
